export enum FileType {
  AUDIO,
  FILE,
  IMAGE,
  SLIDE,
  VIDEO
}
